/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED ANSWERSET : STYLES --------------- ++++++++++ */
export default theme => ({
	answerset: {
		width: '100%',
		height: '60%',
		paddingTop: pxToEm(10),
		'&.isDraggingOver-true':{
			'& .isDragging-false':{
				zIndex: `4000 !important`
				}
			},
		// ..... TEXT 1 ..... //
		'&.text1': {
			display: 'flex',
			flexDirection: 'column'
		 },
		 // ..... TEXT 2 ..... //
		 '&.text2': {
			display: 'flex',
			flexDirection: 'column'
		 },
		// ..... IMAGE 1 ..... //
		'&.image1': {
			display: 'flex',
			flexWrap: 'nowrap',
			alignItems: 'center',
			'&.isDraggingOver-false':{
				justifyContent: 'space-around'
			},
			'&.isDraggingOver-true':{
				'&.in-content':{'& .isDragging-false': {  margin: `0 ${pxToEm(30)}`}},
				'&.rail':{'& .isDragging-false': {  marginRight: pxToEm(10)}}
			},
			'&.answeramount-2': {
				fontSize: '120%',
				'& .answer .graphic': { fontSize: '110%' }
			},
			'&.answeramount-4': {
				fontSize: '85%',
				'& .answer .graphic': { fontSize: '85%' }
			}
		},

		// ..... IMAGE 2 ..... //
		'&.image2': {
			display: 'flex',
			alignItems: 'center',
			'&.isDraggingOver-false':{
				justifyContent: 'space-around'
			},
			'&.isDraggingOver-true':{
				'&.in-content':{'& .isDragging-false': {  margin: `0 ${pxToEm(10)}`}},
				'&.rail':{'& .isDragging-false': {  marginRight: pxToEm(10)}}
			},
			'& .draggable':{
				height: '100%'
			},
			'& .answer': {
				height: '100%',
				width: '100%',
				marginRight: pxToEm(7),
				'&:last-child': { marginRight: '0' }
			},
			'&.answeramount-2': {
				'& .draggable': {
					width: '45%'
				}
			},
			'&.answeramount-3': {
				'& .draggable': {
					width: '30%'
				}
			},
			'&.answeramount-4': {
				fontSize: '85%',
				'& .draggable': {
					width: '22%'
				}
			}
		},

		// ..... EMOJI ..... //
		'&.emoji': {
			display: 'flex',
			alignItems: 'center',
			'& .answer': { width: '100%' },
			'&.isDraggingOver-false':{
				justifyContent: 'space-around'
			},
			'&.isDraggingOver-true':{
				'&.in-content':{'& .isDragging-false': {  margin: `0 ${pxToEm(10)}`}},
				'&.rail':{'& .isDragging-false': {  marginRight: pxToEm(10)}}
			},
			'&.answeramount-2': {
				fontSize: '120%',
				'& .draggable': { width: '46%' },
				'& .answer .graphic': { fontSize: '110%' }
			},
			'&.answeramount-3': {
				fontSize: '110%',
				'& .draggable': { width: '32%' },
				'& .answer .graphic': { fontSize: '100%' }
			},
			'&.answeramount-4': {
				fontSize: '85%',
				'& .draggable': { width: '23%' },
				'& .answer .graphic': { fontSize: '90%' }
			}
		}
	}
});
